// Gedeelde opmaak van de tabelbouwstenen. Kleuren alleen via tokens, zodat donker vanzelf volgt.

/** Eigen zichtbare focus; `!` wint van `*:focus-visible { outline: none }` in `globals.css:156-160`. */
export const FOCUS_CLASS =
  'focus-visible:outline-2! focus-visible:outline-offset-2! focus-visible:outline-solid! focus-visible:outline-[var(--secondary)]!';

/** Touchdoel ≥ 44 px onder 768 px, compact daarboven. */
export const CONTROL_CLASS = `min-h-11 md:min-h-9 rounded-[var(--radius-control)] border border-[var(--border)] bg-[var(--background)] px-3 text-sm text-[var(--foreground)] ${FOCUS_CLASS}`;

export const POPUP_CLASS =
  'absolute left-0 top-full z-20 mt-1 min-w-full w-64 max-w-[calc(100vw-2rem)] rounded-[var(--radius-control)] border border-[var(--border)] bg-[var(--background)] py-1 shadow-lg';

export const MELDING_CLASS = 'px-3 py-1.5 text-xs text-[var(--foreground-muted)]';

/** Actieve regel: alleen de achtergrond markeert (contrastnoot `KlantZoeker.tsx:182-185`). */
export const regelClass = (actief: boolean) =>
  `flex min-h-11 md:min-h-0 cursor-pointer items-center gap-2 px-3 py-1.5 text-sm text-[var(--foreground)] border-l-2 ${
    actief ? 'border-[var(--primary)] bg-[var(--background-muted)] pl-[10px]' : 'border-transparent'
  }`;
